import { PollDetail } from 'src/lib/hooks/polls/useGetPollDetails';

export const QUESTION_TYPE: any = {
  INTEGER: 'INTEGER',
  MULTIPLE: 'MULTIPLE',
  SINGLE: 'SINGLE',
  VOTE: 'VOTE',
};

export const convertSecondsToHHMMSSFormat = (
  totalSeconds: number,
  showMMSSFormate = false,
): string => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Pad hours, minutes, and seconds with leading zeros if necessary
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');
  if (showMMSSFormate && hours === 0) {
    return `${formattedMinutes}:${formattedSeconds}`;
  }
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const formatTime = (timeInSeconds: any) => {
  if (timeInSeconds > 0) {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    let str = '';
    if (minutes > 0) {
      str += `${minutes}m`;
    }
    if (seconds > 0 || str === '') {
      if (Number.isInteger(seconds)) {
        str += ` ${seconds}s`;
      } else {
        str += ` ${Number(seconds)?.toFixed(2)?.toString()}s`;
      }
    }
    return str.trim();
  }
  return '-';
};

export const POLL_STATUS: any = {
  POLL_STARTED: 'Poll started',
  RESULT_AWAITING: 'Awaiting Poll Results',
  RESULT_GENERATED: 'Results',
  SHOWING_RESULT: 'Showing result',
};

export const setPollDetailsToStorage = (data: PollDetail) => {
  localStorage.setItem('activePollDetails', JSON.stringify(data));
};

export const getPollDetailsFromStorage = () => {
  return JSON.parse(localStorage.getItem('activePollDetails') || JSON.stringify({}));
};

export const removePollFromStorage = () => {
  return localStorage.removeItem('activePollDetails');
};

export const setActivePollSelectedAnswerToStorage = (data: any) => {
  localStorage.setItem('activePoll', JSON.stringify(data));
};

export const getActivePollSelectedAnswerFromStorage = () => {
  return JSON.parse(localStorage.getItem('activePoll') || JSON.stringify({}));
};

export const removeActivePollSelectedAnswerFromStorage = () => {
  return localStorage.removeItem('activePoll');
};

export const setLiveTokenToStorage = (data: any) => {
  localStorage.setItem('liveToken', JSON.stringify(data));
};

export const getLiveTokenFromStorage = () => {
  return JSON.parse(localStorage.getItem('liveToken') || JSON.stringify(''));
};

export const removeLiveTokenFromStorage = () => {
  return localStorage.removeItem('liveToken');
};

export const setExpiryTimeToStorage = (data: any) => {
  localStorage.setItem('liveTokenExpiryTime', JSON.stringify(data));
};

export const getExpiryTimeFromStorage = () => {
  return JSON.parse(localStorage.getItem('liveTokenExpiryTime') || JSON.stringify(''));
};

export const removeExpiryTimeFromStorage = () => {
  return localStorage.removeItem('liveTokenExpiryTime');
};

export const setCallStartTime = (data: any) => {
  localStorage.setItem('callStartTime', JSON.stringify(data));
};

export const getCallStartTimeFromStorage = () => {
  return JSON.parse(localStorage.getItem('callStartTime') || JSON.stringify(''));
};

export const removeCallStartTimeFromStorage = () => {
  return localStorage.removeItem('callStartTime');
};

export const setCallEndTime = (data: any) => {
  localStorage.setItem('callEndTime', JSON.stringify(data));
};

export const getCallEndTimeFromStorage = () => {
  return JSON.parse(localStorage.getItem('callEndTime') || JSON.stringify(''));
};

export const removeCallEndTimeFromStorage = () => {
  return localStorage.removeItem('callEndTime');
};
export const setShowLeaderBoardClicked = (data: any) => {
  localStorage.setItem('showLeaderBoardClicked', JSON.stringify(data));
};

export const getShowLeaderBoardClickedFromStorage = () => {
  return JSON.parse(localStorage.getItem('showLeaderBoardClicked') || JSON.stringify(''));
};

export const removeShowLeaderBoardClickedFromStorage = () => {
  return localStorage.removeItem('showLeaderBoardClicked');
};

export const setPollIdToStorage = (data: any) => {
  localStorage.setItem('pollId', JSON.stringify(data));
};

export const getPollIdFromStorage = () => {
  return JSON.parse(localStorage.getItem('pollId') || JSON.stringify(''));
};

export const removePollIdFromStorage = () => {
  return localStorage.removeItem('pollId');
};

export class GeneratedResultModel {
  result: PollDetail;
  leaderboard: Array<LeaderBoardModel> = [];
  constructor(data: any) {
    if (data && data.result && data.result.length > 0) {
      // No Empty block needed here
    }
    this.result = new PollDetail(data?.result);

    if (data && data.leaderboard && data.leaderboard.length > 0) {
      const leaderBoard: Array<LeaderBoardModel> = [];
      data.leaderboard.forEach((el: LeaderBoardModel) => {
        leaderBoard.push(new LeaderBoardModel(el));
      });
      this.leaderboard = [...this.leaderboard, ...leaderBoard];
    }
  }
}

export class GeneratedLeaderBoardModel {
  totalPollsConducted: number;
  leaderboard: Array<SelfStats> = [];
  constructor(data: any) {
    if (data && data.result && data.result.length > 0) {
      // No Empty block needed here
    }
    this.totalPollsConducted = data.totalPollConducted;

    if (data && data.leaderboard && data.leaderboard.length > 0) {
      const leaderBoard: Array<SelfStats> = [];
      for (let i = 0; i < data.leaderboard.length; i++) {
        const el = data.leaderboard[i];
        leaderBoard.push(new SelfStats(el));
      }
      this.leaderboard = [...this.leaderboard, ...leaderBoard];
    }
  }
}

export class LeaderBoardList {
  _id: string;
  option_id: Array<any>;
  poll_id: string;
  time_taken: string;
  created_by: any;
  poll_entity_id: string;
  poll_entity_type: string;
  created_at: string;
  points_earned: number;
  rank: number;
  total_count: number;
  user_Id: UserID;
  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.option_id = data.option_id || data.optionId || '';
    this.poll_id = data.poll_id || data.pollId || '';
    this.time_taken = data.time_taken || data.timeTaken || '';

    this.created_by = data.created_by || data.createdBy;
    this.user_Id = new UserID(data.userId || {});

    this.poll_entity_id = data.poll_entity_id || data.pollEntityId || '';
    this.poll_entity_type = data.poll_entity_type || data.pollEntityType || '';
    this.created_at = data.created_at || data.createdAt || '';
    this.points_earned = Math.abs(data.points_earned) || Math.abs(data.pointsEarned) || 0;
    this.rank = data.rank || 0;
    this.total_count = data.total_count || data.totalCount || 0;
  }
}

export class UserID {
  _id: string;
  first_Name: string;
  last_Name: string;
  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.first_Name = data.firstName || '';
    this.last_Name = data.lastName || '';
  }
}

export class LeaderBoardModel {
  _id: string;
  option_id: Array<any>;
  poll_id: string;
  time_taken: string;
  created_by: any;
  poll_entity_id: string;
  poll_entity_type: string;
  created_at: string;
  points_earned: number;
  rank: number;
  total_count: number;
  user_Id: UserID;
  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.option_id = data.option_id || data.optionId || '';
    this.poll_id = data.poll_id || data.pollId || '';
    this.time_taken = data.time_taken || data.timeTaken || '';

    this.created_by = data.created_by || data.createdBy;
    this.user_Id = new UserID(data.userId || {});

    this.poll_entity_id = data.poll_entity_id || data.pollEntityId || '';
    this.poll_entity_type = data.poll_entity_type || data.pollEntityType || '';
    this.created_at = data.created_at || data.createdAt || '';
    this.points_earned = Math.abs(data.points_earned) || Math.abs(data.pointsEarned) || 0;
    this.rank = data.rank || 0;
    this.total_count = data.total_count || data.totalCount || 0;
  }
}

export class SelfStats {
  _id: string;
  entityType: string;
  entityId: number;
  entityIds: Array<number>;
  userId: string;
  rank: number;
  averageCorrectAnsweredTime: string;
  correctAnswered: string;
  totalPollAttempted: number;
  totalPollConducted: number;

  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.entityType = data.entityType || '';
    this.entityId = data.entityId || 0;
    this.entityIds = data.entityIds || [];
    this.userId = data.userId || '';
    this.rank = data.rank || 0;
    this.averageCorrectAnsweredTime = data.averageCorrectAnsweredTime || '';
    this.correctAnswered = data.correctAnswered || '';
    this.totalPollAttempted = data.totalPollAttempted || 0;
    this.totalPollConducted = data.totalPollConducted || 0;
  }
}

export type POLL_TYPE = 'LIVE_POLL' | 'NON_LIVE_POLL' | '';

export enum POLL_TYPE_ENUM {
  LIVE = 'LIVE_POLL',
  NON_LIVE = 'NON_LIVE_POLL',
}
// const FEEDBACK_SUBMITTED_KEY: string = 'feedback_submitted_array';
const ACTIVE_POST_POLL_ID: string = 'post_poll_id';

// POST POLL HANDLING

export const tooltipClass =
  '!bg-white !text-[#1B2124] !z-[99999] !pointer-events-auto cursor-pointer';
export const tooltipClassForTimestamp =
  '!w-[240px] !bg-[#414347] !text-white !z-[99999] !pointer-events-auto cursor-pointer';

export const getPostPollIdFromLocalStroage = () =>
  JSON.parse(localStorage.getItem(ACTIVE_POST_POLL_ID) || JSON.stringify(''));

export const setPostPollIdToLocalStorage = (id: string) =>
  localStorage.setItem(ACTIVE_POST_POLL_ID, JSON.stringify(id));

export const removePostPollIdFromLocalStorage = () => localStorage.removeItem(ACTIVE_POST_POLL_ID);

export const setActivePostPollSelectedAnswerToStorage = (data: any) => {
  localStorage.setItem('activePostPoll', JSON.stringify(data));
};

export const getActivePostPollSelectedAnswerFromStorage = () => {
  return JSON.parse(localStorage.getItem('activePostPoll') || JSON.stringify({}));
};
export const removeActivePostPollSelectedAnswerFromStorage = () => {
  return localStorage.removeItem('activePostPoll');
};

export enum DESIGN_VARIANT {
  OLD = 'old',
  NEW = 'new',
}

export const pollDefaultEventData = {
  lecture_type: 'recorded',
  source: '',
  poll_id: '',
  start_time: 0,
  received_time: 0,
};
